import { render, staticRenderFns } from "./afterBid.vue?vue&type=template&id=3e395270&scoped=true"
import script from "./afterBid.vue?vue&type=script&lang=js"
export * from "./afterBid.vue?vue&type=script&lang=js"
import style0 from "./afterBid.vue?vue&type=style&index=0&id=3e395270&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e395270",
  null
  
)

export default component.exports